export { default } from './Tour';
